import logo from './logo.svg';
import './App.css';
import config from './config';
import React, { useContext, useState, useEffect, useReducer } from 'react';
import { SearchContext } from "./context";
import { rootlink, URL_MW, thumbnailConfig, blue } from './config';
import { default_config, default_viewinfo, default_photolist, default_branchlist, default_planlist, imgConfig, category_mapping, menu_mapping, plates, order_mapping_search } from './config';
import './css/common.scss';
import './css/bulma-tune.scss';
/////////////// swiper start 
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Thumbs } from 'swiper/core';
import loadingicon from './img/loading.gif';
import { Navigation, Pagination, Scrollbar, A11y, Lazy } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
/////////////// swiper end 
import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import $ from "jquery";

import GalleryDesktop from './GalleryDesktop';
import GalleryMobile from './GalleryMobile';

var ts = 0;

const Gallery = () => {

  const navigate = useNavigate();

  function golink(p) {
    var url = "/mw_v2/viewlist/details/?id=" + p['value'];
    window.open(url, '_blank');
  }

  function ltrbox(action) {
    if (action == "show") {
      // document.getElementById('lightrail').style.display = 'block';
      $("#lightrail").fadeIn(500);
    } else {
      // document.getElementById('lightrail').style.display = 'none';
      $("#lightrail").fadeOut(500);
    }
  }

  const [searchParams, setSearchParams] = useSearchParams();
  const viewid = searchParams.get("id");
  const blockFlat = searchParams.get("block_flat");
  // const params = useParams();
  // const viewid = params.id;

  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);

  // const page = useContext(SearchContext).page;
  const [loaded, setLoaded] = useState(false);
  const [viewinfo, setViewInfo] = useState(default_viewinfo);
  const [photolist, setPhotoList] = useState(default_photolist);
  const [planlist, setPlanList] = useState(default_planlist);
  const [branchlist, setBranchList] = useState(default_branchlist);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [config, setConfig] = useReducer(function (state, action) {
    switch (action.type) {
    }
    return state;
  }, JSON.parse(JSON.stringify(default_config)));

  const navigateToBlockFlat = (nextBlockFlat) => {
    const nextParams = new URLSearchParams(searchParams);
    if (viewid) {
      nextParams.set('id', viewid);
    }
    nextParams.set('block_flat', nextBlockFlat);
    setSearchParams(nextParams);
  };

  const search = () => {
    var url;
    ts = new Date().getTime();
    url = "https://www.manyw.com/view/view_prop.php?category=viewgallery&auto_no=" + viewid;
    if (blockFlat) {
      url += "&block_flat=" + encodeURIComponent(blockFlat);
    }
    url += "&thumbnail_width=" + imgConfig.width;
    url += "&thumbnail_height=" + imgConfig.height;
    url += '&ts=' + ts;

    // console.log(url);
    setLoaded(false);
    fetch(url, { method: "POST", body: config })
      .then(res => res.json())
      .then(res => {
        // console.log(res);
        if (res.ts == ts) {
          setViewInfo(res['data']);
          setPhotoList(res['data']['photo_list']);

          if (res['data']['auto_no'] && res['data']['auto_no'] !== viewid) {
            const nextParams = new URLSearchParams(searchParams);
            nextParams.set('id', res['data']['auto_no']);
            if (res['data']['block_flat']) {
              nextParams.set('block_flat', res['data']['block_flat']);
            }
            setSearchParams(nextParams, { replace: true });
          }

          setLoaded(true);
          document.title = res['data']['doc_name'] + " 室內相及景觀 - 祥益地產";
        }
      })
      .catch(err => console.log(err))
      .finally(() => { });
  }

  useEffect(() => {
    if (!viewid) return;
    search();
  }, [
    viewid,
    blockFlat,
    JSON.stringify(config.bldg),
    config.region.length,
    config.rent.from,
    config.rent.to,
    config.room.length,
    config.floor.length,
    config.net.from,
    config.net.to,
    config.proptype.length,
  ]);
  useEffect(()=>{
    document.title = viewinfo['doc_name'] + " 室內相及景觀 - 祥益地產";
  },[
    loaded
  ]);
  
// if(loaded){
//   console.log(viewinfo);
// }

  return (<div>

    {/*Gallery.sql1*/}
    <div className='mobile-hidden'>
      <GalleryDesktop
        loaded={loaded}
        viewinfo={viewinfo}
        photolist={photolist}
        planlist={planlist}
        branchlist={branchlist}
        onBlockFlatChange={navigateToBlockFlat}
      />
    </div>

    <div className='mobile-display'>
      <GalleryMobile
        loaded={loaded}
        viewinfo={viewinfo}
        photolist={photolist}
        planlist={planlist}
        branchlist={branchlist}
        onBlockFlatChange={navigateToBlockFlat}
      />
    </div>

  </div>
  )

  return null;
}

export default Gallery;
